import { render, staticRenderFns } from "./InfosSpecificitySection.vue?vue&type=template&id=d67b7a3e"
import script from "./InfosSpecificitySection.vue?vue&type=script&lang=js"
export * from "./InfosSpecificitySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports